export default "__VITE_ASSET__44304027__"